import Vue from "vue";
import App from "./App.vue";
import Vuex from "vuex";
import store from "./store";
import ElementUI from "element-ui";
import Axios from "axios";
import de from "element-ui/lib/locale/lang/de";
import en from "element-ui/lib/locale/lang/en";
import fr from "element-ui/lib/locale/lang/fr";
import "element-ui/lib/theme-chalk/index.css";
import "element-ui/lib/theme-chalk/display.css";
import { VueReCaptcha } from "vue-recaptcha-v3";
import * as shajs from "sha.js";
import locale from "element-ui/lib/locale";

Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(ElementUI);

// https://github.com/AurityLab/recaptcha-v3/#load-options-usage
// https://developers.google.com/recaptcha/docs/faq#id-like-to-hide-the-recaptcha-v3-badge-what-is-allowed
Vue.use(VueReCaptcha, {
  siteKey: "6LflAVUaAAAAALV70Vqhv6s_xIrn7xRmSlF3_-nc",
  loaderOptions: {
    autoHideBadge: true,
  },
});

// Globals
Vue.prototype.$http = Axios;
Vue.prototype.$sha = shajs;

new Vue({
  store,
  data: {
    urlParamId: "",
  },
  created() {
    /** The hashed data */
    this.urlParamId = window.location.pathname.slice(1);

    if (this.urlParamId == null) {
      return;
    }

    var urlParamList = [];

    // decode url - split into params and save them in the store
    this.urlParamId = window.atob(this.urlParamId);
    this.urlParams = new URLSearchParams(window.location.href);

    this.urlParams.delete("http://localhost:8080/?id");
    this.urlParams.forEach(function (value, key) {
      var tmp = {};
      tmp[key] = value;
      urlParamList.push(tmp);
    });

    // remove quotes
    this.urlParamId = this.urlParamId.replace(/&quot;/g, '"');

    let params = JSON.parse(this.urlParamId);

    // set the url parameter in the global store
    this.$store.commit("setCustomer", params.customer);
    this.$store.commit("setUserHash", params.userHash);
    this.$store.commit("setWebformHash", params.webformHash);
    this.$store.commit("setLanguageIdIntern", params.languageId);
    this.$store.commit("setUrlParams", urlParamList);

    // detect language
    switch (params.languageId) {
      case 1:
        this.$store.commit("setLanguageId", "de-DE");
        locale.use(de);
        break;
      case 2:
        this.$store.commit("setLanguageId", "en-GB");
        locale.use(en);
        break;
      case 3:
        this.$store.commit("setLanguageId", "fr-FR");
        locale.use(fr);
        break;
      default:
        this.$store.commit("setLanguageId", "en-GB");
        locale.use(en);
    }

    // detect browser
    var browser,
      userAgent = navigator.userAgent;
    if (userAgent.indexOf("Firefox") > -1) {
      browser = "Mozilla Firefox";
      // "Mozilla/5.0 (X11; Ubuntu; Linux x86_64; rv:61.0) Gecko/20100101 Firefox/61.0"
    } else if (userAgent.indexOf("SamsungBrowser") > -1) {
      browser = "Samsung Internet";
      // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36
    } else if (
      userAgent.indexOf("Opera") > -1 ||
      userAgent.indexOf("OPR") > -1
    ) {
      browser = "Opera";
      // "Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_0) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/70.0.3538.102 Safari/537.36 OPR/57.0.3098.106"
    } else if (userAgent.indexOf("Trident") > -1) {
      browser = "Microsoft Internet Explorer";
      // "Mozilla/5.0 (Windows NT 10.0; WOW64; Trident/7.0; .NET4.0C; .NET4.0E; Zoom 3.6.0; wbx 1.0.0; rv:11.0) like Gecko"
    } else if (userAgent.indexOf("Edge") > -1) {
      browser = "Microsoft Edge";
      // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
    } else if (userAgent.indexOf("Chrome") > -1) {
      browser = "Google Chrome or Chromium";
      // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Ubuntu Chromium/66.0.3359.181 Chrome/66.0.3359.181 Safari/537.36"
    } else if (userAgent.indexOf("Safari") > -1) {
      browser = "Apple Safari";
      // "Mozilla/5.0 (iPhone; CPU iPhone OS 11_4 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/11.0 Mobile/15E148 Safari/604.1 980x1306"
    } else {
      browser = "unknown";
    }

    // set browser and userAgent in the global
    this.$store.commit("setOs", browser);
    this.$store.commit("setDeviceId", userAgent);
  },
  computed: {
    ViewComponent() {
      return App;
    },
  },
  render(h) {
    return h(this.ViewComponent);
  },
}).$mount("#app");
